import { Box } from '@mui/material'
import { TabPanelProps } from './TabPanel.types'

export const TabPanel = ({
  children,
  value,
  index,
  padding = 3,
  ...rest
}: TabPanelProps) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...rest}
    >
      {value === index && <Box p={padding}>{children}</Box>}
    </div>
  )
}
